// A vanilla JS equivalent to jQuery's parents() function
// Gets the ancestors of each element in the current set of matched elements, optionally filtered by a selector.

import { Nullable } from "~/types/types.util"

export function parents(element: Element, selector?: string) {
  const parents = []
  let parent: Nullable<Element> = element
  while (parent) {
    // Include this "parent" if either we don't have a selector at all,
    // or we have one and it matches
    if (!selector || parent.matches(selector)) {
      parents.push(parent)
    }
    parent = parent.parentElement
  }
  return parents
}

export function isElementVisible(el: Element, holder = document.body) {
  const { top, bottom, height } = el.getBoundingClientRect()
  const holderRect = holder.getBoundingClientRect()

  return top <= holderRect.top ? holderRect.top - top <= height : bottom - holderRect.bottom <= height
}

export function index(el: Element): number {
  if (!el || !el.parentNode) return -1

  let index = 0
  let sibling = el.previousElementSibling

  while (sibling) {
    index++
    sibling = sibling.previousElementSibling
  }

  return index
}

export function isTouchDevice() {
  return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0))
}

export function makeClickable(element: HTMLElement, callback: (event: Event) => void) {
  // This currently overrides any existing role or tabindex attributes
  element.role = "button"
  element.tabIndex = 0

  const onKeydown = (e: KeyboardEvent) => {
    if (e.key === "Enter") callback(e)
    if (e.key === " ") {
      e.preventDefault()
      callback(e)
    }
  }

  element.addEventListener("click", callback)
  element.addEventListener("keydown", onKeydown)

  const cleanup = () => {
    element.removeAttribute("role")
    element.removeAttribute("tabindex")
    element.removeEventListener("click", callback)
    element.removeEventListener("keydown", onKeydown)
  }

  return cleanup
}
